"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCode = exports.weekData = void 0;
exports.weekData = {
    firstDay: {
        '001': 'mon',
        AD: 'mon',
        AE: 'sat',
        AF: 'sat',
        AG: 'sun',
        AI: 'mon',
        AL: 'mon',
        AM: 'mon',
        AN: 'mon',
        AR: 'mon',
        AS: 'sun',
        AT: 'mon',
        AU: 'mon',
        AX: 'mon',
        AZ: 'mon',
        BA: 'mon',
        BD: 'sun',
        BE: 'mon',
        BG: 'mon',
        BH: 'sat',
        BM: 'mon',
        BN: 'mon',
        BR: 'sun',
        BS: 'sun',
        BT: 'sun',
        BW: 'sun',
        BY: 'mon',
        BZ: 'sun',
        CA: 'sun',
        CH: 'mon',
        CL: 'mon',
        CM: 'mon',
        CN: 'mon',
        CO: 'mon',
        CR: 'mon',
        CY: 'mon',
        CZ: 'mon',
        DE: 'mon',
        DJ: 'sat',
        DK: 'mon',
        DM: 'sun',
        DO: 'sun',
        DZ: 'sat',
        EC: 'mon',
        EE: 'mon',
        EG: 'sat',
        ES: 'mon',
        ET: 'sun',
        FI: 'mon',
        FJ: 'mon',
        FO: 'mon',
        FR: 'mon',
        GB: 'mon',
        GE: 'mon',
        GF: 'mon',
        GP: 'mon',
        GR: 'mon',
        GT: 'sun',
        GU: 'sun',
        HK: 'sun',
        HN: 'sun',
        HR: 'mon',
        HU: 'mon',
        ID: 'sun',
        IE: 'mon',
        IL: 'sun',
        IN: 'sun',
        IQ: 'sat',
        IR: 'sat',
        IS: 'mon',
        IT: 'mon',
        JM: 'sun',
        JO: 'sat',
        JP: 'sun',
        KE: 'sun',
        KG: 'mon',
        KH: 'sun',
        KR: 'sun',
        KW: 'sat',
        KZ: 'mon',
        LA: 'sun',
        LB: 'mon',
        LI: 'mon',
        LK: 'mon',
        LT: 'mon',
        LU: 'mon',
        LV: 'mon',
        LY: 'sat',
        MA: 'sat',
        MC: 'mon',
        MD: 'mon',
        ME: 'mon',
        MH: 'sun',
        MK: 'mon',
        MM: 'sun',
        MN: 'mon',
        MO: 'sun',
        MQ: 'mon',
        MT: 'sun',
        MV: 'fri',
        MX: 'mon',
        MY: 'mon',
        MZ: 'sun',
        NI: 'sun',
        NL: 'mon',
        NO: 'mon',
        NP: 'sun',
        NZ: 'mon',
        OM: 'sat',
        PA: 'sun',
        PE: 'sun',
        PH: 'sun',
        PK: 'sun',
        PL: 'mon',
        PR: 'sun',
        PT: 'mon',
        PY: 'sun',
        QA: 'sat',
        RE: 'mon',
        RO: 'mon',
        RS: 'mon',
        RU: 'mon',
        SA: 'sun',
        SD: 'sat',
        SE: 'mon',
        SG: 'mon',
        SI: 'mon',
        SK: 'mon',
        SM: 'mon',
        SV: 'sun',
        SY: 'sat',
        TH: 'sun',
        TJ: 'mon',
        TM: 'mon',
        TN: 'sun',
        TR: 'mon',
        TT: 'sun',
        TW: 'sun',
        UA: 'mon',
        UM: 'sun',
        US: 'sun',
        UY: 'mon',
        UZ: 'mon',
        VA: 'mon',
        VE: 'sun',
        VI: 'sun',
        VN: 'mon',
        WS: 'sun',
        XK: 'mon',
        YE: 'sun',
        ZA: 'sun',
        ZW: 'sun'
    }
};
var getCountryCode = function (locale) {
    var tokens = locale && locale.split(/_|-/);
    // eslint-disable-next-line no-magic-numbers
    if (tokens && tokens.length > 1) {
        // eslint-disable-line no-magic-numbers
        return tokens[1]; // eslint-disable-line no-magic-numbers
    }
    else {
        return 'US';
    }
};
exports.getCountryCode = getCountryCode;
//# sourceMappingURL=locale-data.js.map